<template>
	<div class="class">
		<teacherNav :current="current" @info-event="myInfoEvent" @public-event="publicEvent"></teacherNav>
		<div class="class_cont bg_blue">
			<div class="class_div radius8 bs bg_white">
				<div class="class_title flex">
					<p class="f30px cl_dark">数据报告・知识点分析</p>
				</div>
				<div class="student_report_screen">
					<div class="flex mar20 f16px kno_report_class mab10">
						<div class="cur bg_gray cl_gray kno_report_class_list tc" v-for="(item,index) in class_list" :key="index" :class="{'on':item.id==class_cur}"
						 @click="classCheck(item.id)">{{item.name}}</div>
					</div>
					<div class="famous_screen_list flex mab10 mar20">
						<span class="cl_gray f18px">学科：</span>
						<el-select v-model="subject_cur" placeholder="全部" clearable>
							<el-option v-for="(item,index) in subject":key="index" :label="item.subjectName":value="item.subjectId"></el-option>
						</el-select>
					</div>
					<input type="text" placeholder="知识点名称" v-model="name" class="kon_report_name mab10 mar20 mal20" />
					<button class="f16px cl_white student_report_screen_btn mab10 mal20" @click="submit">查询</button>
				</div>
				<div class="">
					<table class="kno_table">
						<thead>
							<tr class="f18px">
								<th width="410px">知识点名称</th>
								<th width="240px">学科</th>
								<th width="240px">学科答题学生数</th>
								<th width="240px">人均学科答题数</th>
								<th width="240px">平均学科答题正确率</th>
							</tr>
						</thead>
						<tbody class="f16px cl_dark">
							<tr v-for="(item,index) in list" :key="index">
								<td>{{item.knowledgeName}}</td>
								<td align="center">{{item.subjectName}}</td>
								<td align="center">{{item.answer_student_num}}</td>
								<td align="center">{{item.answer_per_capita_num}}</td>
								<td align="center">{{item.answer_accuracy}}%</td>
							</tr>
							<tr>
								<td v-if="loading" colspan="5" style="text-align: center;padding-left: 0;">加载中</td>
							</tr>
							<tr>
								<td v-if="list.length == 0 && loading == false" colspan="5" style="text-align: center;padding-left: 0;">无数据</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="famous_page flex" v-if="list.length > 0">
					<div class="famous_page_l f16px cl_gray"> </div>
					<div class="famous_page_r cl_dark">
						<el-pagination background layout="prev, pager, next"
						@current-change="handleCurrentChange" :page-size="pageSize" :current-page="currentPage" :total="total"></el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import teacherNav from '../../components/teacher_nav.vue'
	
	export default {
		name: 'class_manage',
		components: {
			teacherNav,
		},
		props: {
			
		},
		data () {
			return {
				myInfo: {},
				public: {},
				current: {
					navCur: 7,
					listCur: 4,
					open: 0,
				},
				subject: [],
				subject_cur: "",
				class_list: [
					{
						id: 1,
						name: "全部",
					},{
						id: 2,
						name: "行政班",
					},{
						id: 3,
						name: "教学班",
					},
				],
				class_cur: 1,
				name: "",
				list: [],
				currentPage: 1, //当前页数
				pageSize: 20, //每页数量
				total: 0, //总页数
				loading: true,
			}
		},
		created() {
			
		},
		mounted() {
			this.getSubject();
			this.getList();
		},
		methods: {
			myInfoEvent (data) {
				this.myInfo = data;
			},
			publicEvent (data) {
				this.public = data;
			},
			//学科
			getSubject () {
				this.$get("/api/material/get_subject_data",{})
				.then(res => {
					this.subject = res.data;
				});
			},
			classCheck (id) {
				this.class_cur = id;
			},
			getList () {
				this.$get("/api/teacher/get_knowledge_basic_analyse",{
					token: localStorage.getItem("token"),
					type: this.class_cur,
					subject_id: this.subject_cur,
					name: this.name,
					page: this.currentPage,
					limit: this.pageSize,
				})
				.then(res => {
					this.list = res.data.data;
					this.total = res.data.total;
					this.loading = false;
				});
			},
			submit () {
				this.list = [];
				this.currentPage = 1;
				this.loading = true;
				this.getList();
			},
			handleCurrentChange: function(currentPage){
				this.currentPage = currentPage;
				this.getList();
			},
		},
	}
</script>

<style>
</style>
